/**
 * 检查字符串内容是否有效
 */
export const isValidStringContent = (
    content: unknown,
    type: string,
): boolean => {
    if (typeof content !== 'string') {
        console.warn(
            `Invalid content format for type ${type}: expected string, got ${typeof content}`,
        );
        return false;
    }
    if (!content.trim()) {
        console.warn(`Empty content for type ${type}`);
        return false;
    }
    return true;
};

/**
 * 检查版权图片内容是否有效
 */
export const isValidCopyrightedImageContent = (
    content: unknown,
    type: string,
): boolean => {
    if (typeof content !== 'object' || content === null) {
        console.warn(
            `Invalid content format for type ${type}: expected object, got ${typeof content}`,
        );
        return false;
    }

    const copyrightedContent = content as { url: string; copyright: string };
    if (
        typeof copyrightedContent.url !== 'string' ||
        typeof copyrightedContent.copyright !== 'string'
    ) {
        console.warn(
            `Invalid copyrighted image content structure for type ${type}`,
        );
        return false;
    }

    if (
        !copyrightedContent.url.trim() ||
        !copyrightedContent.copyright.trim()
    ) {
        console.warn(`Empty url or copyright for type ${type}`);
        return false;
    }

    return true;
};
